import { Grid } from "@mui/material";
import React from "react";
import { Input, InputDate, InputImg, Select } from "../../../controls";
import { DropLi } from "../../../hooks";

const AdditionalFields = ({
  values,
  setValues,
  handleFile,
  handleInpChg,
  handleInpDate,
}) => {
  const { Gender } = DropLi();
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        <Select
          label="Gender"
          name="gender"
          value={values.gender}
          onChange={handleInpChg}
          options={Gender}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <InputDate
          label="Date of Birth"
          name="dob"
          value={values.dob}
          onChange={(date) =>
            handleInpDate("dob", new Date(date).toLocaleDateString())
          }
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Input
          label="Twitter"
          name="twitter"
          value={values.twitter}
          inputProps={{ maxLength: 500 }}
          onChange={handleInpChg}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Input
          label="Website"
          name="website"
          value={values.website}
          inputProps={{ maxLength: 1000 }}
          onChange={handleInpChg}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <Input
          label="Company Name"
          name="company"
          value={values.company}
          inputProps={{ maxLength: 200 }}
          onChange={handleInpChg}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <InputImg
          label="Profile Picture"
          name="photoFile"
          src={values.photo}
          value={values.photoFile}
          rmv={() => {
            setValues({ ...values, photoFile: "", photo: "" });
          }}
          onChange={handleFile}
        />
      </Grid>
    </Grid>
  );
};

export default AdditionalFields;
